import type { Routes } from "@angular/router";
import { ContractsList } from "./contracts-list/contracts-list";
import { Contract } from "./contract/contract";
import { hasPermissionGuard } from "../../../guards/has-permission-guard";
import { inject } from "@angular/core";
import { firstValueFrom } from "rxjs";
import { LayoutService } from "../../../services/layout.service";

export const contractsRoutes: Routes = [
  {
    path: '',
    loadComponent: () => ContractsList,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Contratos`;
    }
  },
  {
    path: ':id',
    loadComponent: () => Contract,
    title: async () => {
      const title = await firstValueFrom(inject(LayoutService).systemTitle$);
      return `${title} - Contrato`;
    }
  },
]
